'use strict';

var React = require('react'),
    _ = require('underscore'),
    PageControls = require('../molecules/PageControls'),
    ShareAddZine = require('../organisms/ShareAddZine'),
    FollowZineButton = require('../molecules/FollowZineButton'),
    PendingZineButton = require('../molecules/PendingZineButton'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ZineStore = require('../stores/ZineStore'),
    UserStore = require('../stores/UserStore'),
    StampStore = require('../stores/StampStore'),
    StampActionCreators = require('../actions/StampActionCreators'),
    ZinePendingStampStore = require('../stores/ZinePendingStampStore'),
    BackColorMixin = require('../mixins/BackColorMixin'),
    createAnalyticsContextMixin = require('../mixins/createAnalyticsContextMixin'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    isBestOf2014Special = require('../utils/isBestOf2014Special'),
    ZineStatus = require('../constants/ZineStatus'),
    { PropTypes } = React;

var ZinePageControls = React.createClass({
  mixins: [
    createStoreMixin(ZineStore, ZinePendingStampStore, StampStore),
    createAnalyticsContextMixin(AnalyticsSources.ZINE_PAGE_CONTROLS),
    BackColorMixin,
    PureRenderMixin
  ],

  propTypes: {
    zineSlug: PropTypes.string.isRequired
  },

  getStateFromStores(props) {
    var zine = ZineStore.get(props.zineSlug),
        isMeCurator = zine && UserStore.isMe(zine.curator),
        pendingStamps = ZinePendingStampStore.getStamps(props.zineSlug),
        pendingStampUsers = _.uniq(pendingStamps.map(s => UserStore.get(s.user)));

    return {
      zine: zine,
      isMeCurator: isMeCurator,
      pendingStampUsers: pendingStampUsers
    };
  },

  componentDidMount() {
    if (this.state.zine) {
      this.zineDidChange(this.state);
    }
  },

  componentWillReceiveProps(newProps) {
    if (newProps.zineSlug !== this.props.zineSlug) {
      this.setState(this.getStateFromStores(newProps));
    }
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevState.zine !== this.state.zine) {
      this.zineDidChange();
    }
  },

  zineDidChange() {
    var { zine, isMeCurator } = this.state;

    if (isMeCurator) {
      StampActionCreators.requestZinePendingPage(zine.slug, true);
    }
  },

  render() {
    var { zine, isMeCurator, pendingStampUsers } = this.state,
        isSpecial = isBestOf2014Special(zine),
        isUnlisted,
        backColor,
        textColor;

    if (zine) {
      isUnlisted = zine.status === ZineStatus.UNLISTED;
      textColor = zine.backColor;
      backColor = (this.getTextColor(zine.backColor) === 'dark') ?
        '2e2f33' :
        'ffffff';
    }

    return (
      <PageControls textColor={textColor}
                    backColor={backColor}>
        {zine && !zine.isSubscribed && !isMeCurator && !isSpecial && !isUnlisted &&
          <PageControls.Container>
            <FollowZineButton zine={zine}
                              context='PageControls'
                              size='large' />

          </PageControls.Container>
        }

        {zine && isMeCurator && zine.pendingCount > 0 &&
          <PageControls.Container>
            <PendingZineButton zine={zine}
                               context='PageControls'
                               size='large'
                               pendingStampUsers={pendingStampUsers} />
          </PageControls.Container>
        }

        {zine &&
          <PageControls.Container>
            <ShareAddZine zine={zine}
                          context='PageControls'
                          size='large'
                          color='black'
                          overlay
                          split />
          </PageControls.Container>
        }
      </PageControls>
    );
  }
});

module.exports = ZinePageControls;



/** WEBPACK FOOTER **
 ** ./pageControls/ZinePageControls.jsx
 **/